import { styled } from '@mui/material/styles';

export const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
